import React from "react";
import Input from "../../../../components/UI/input/GgInput";
import { IContent, IPMBlock } from "../../../../models/IPages";
import FileButton from "../../../../components/UI/button/FileButton";
import { AddIcon } from "../../../../assets/icons";
import { getImageExtensionFromBase64 } from "../../../../utils";

function FaqHeaderBlock({ data, setData, categoryType, actionData }: IPMBlock) {
  const handleGuideBlock = (val: string, type: keyof IContent) =>
  setData((prev: any) => {
    if (type === "image") {
      const ext = getImageExtensionFromBase64(val);
      return {
        ...prev,
        [type]: `/image/page-management/${categoryType}/faqHeaderBlock1.${ext || "jpeg"
          }`,
        images: [val],
      };
    } 
    return { ...prev, [type]: val };
  });
  return (
    <>
      <div className="title">FAQ Header Block</div>
      <div className="step-list">
        <div className="step-item">
          <div className="inputs-container">
            <Input
              type="text"
              placeholder="Enter title"
              label="Title"
              value={data?.title}
              onChange={(val) => setData({ ...data, title: val })}
              disabled={!actionData?.edit}
            />
          </div>
        </div>
        <div className="step-item">
          <div className="step-item"
            >
            <FileButton
              index={"faq-HeaderImage"}
              icon={{
                leftIcon: <AddIcon size="18" className="icon"/>,
              }}
              value={data?.image}
              stylesType="border"
              onChange={(val) => handleGuideBlock(val, "image")}
              className="cover-image-button"
              disabled={!actionData?.edit}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default FaqHeaderBlock;
